<template>
  <div>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-row>
      <v-col cols="12" class="py-1">
        <v-toolbar color="transparent" flat>
          <v-toolbar-title class="headline-header text-h6 px-0">
            {{ title }}
          </v-toolbar-title>
          <v-spacer />
        </v-toolbar>
      </v-col>
    </v-row>
    <v-divider class="pb-2 divider-header" />
    <v-card outlined>
      <v-card-text>
        <v-btn depressed block x-large color="green" dark @click="submit" :loading="loading">
          <v-icon small left>mdi-send</v-icon>
          Gerar Relatório
        </v-btn>
      </v-card-text>
    </v-card>
    <PDF />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import PDF from '@/views/public/modal/Pdf.vue';
import relatoriosHttp from '@/services/http/resources/configuracao/relatoriosHttp';
import toastMessage from '@/services/util/alertService';

export default {
  name: 'RelatorioMotoristaSemFoto',
  components: {
    PDF,
  },
  metaInfo: {
    title: 'Relatórios Motoristas sem Foto',
    titleTemplate: `%s | ${process.env.VUE_APP_TITLE}`,
  },
  data: () => ({
    loading: false,
    title: 'Relatórios Motoristas sem Foto',
  }),
  methods: {
    ...mapActions('app', ['toggleModalPdf']),
    submit() {
      this.loading = true;
      relatoriosHttp
        .motoristaSemFoto()
        .then(({ data }) => {
          const file = new Blob([data], { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          this.toggleModalPdf(fileURL);
        })
        .catch(() => toastMessage.errorLoading('Erro ao carregar documento.'))
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style></style>
